import React, { useContext, useCallback, useState } from "react";
import ExpandableCard                               from "../../ExpandableCard";
import ParticipantContext                           from "../../../contexts/ParticipantContext";

export default function ParticipantVoicemails() {
  const { participant, getParticipant } = useContext(ParticipantContext);
  const { voicemails = [] } = participant || {};

  if (!participant) return null;

  return (
    <ExpandableCard
      title="Voicemails"
      icon="voicemail"
      badge={voicemails?.length}
      onOpen={getParticipant}
    ></ExpandableCard>
  );
}
